import Skeleton from '../../skeleton'

const AveragesSkeleton = () => {
  return (
    <div className="w-full border border-[#EBEDF0] rounded-xl overflow-hidden">
      <div className="p-4">
        <Skeleton className="!w-6/12" />
        <div className="flex items-center gap-1 mt-1">
          <Skeleton className="!w-4/12" />
        </div>
      </div>

      <div className="w-full py-3 px-4  flex flex-col gap-4 bg-gray min-h-[140px]">
        <div className="flex w-full items-center gap-2.5">
          <Skeleton className="!w-7 !h-7" />
          <div className="w-full">
            <Skeleton className="!w-8/12" />
            <Skeleton className="!w-6/12 mt-1" />
          </div>
        </div>
        <div className="flex w-full items-center gap-2.5">
          <Skeleton className="!w-7 !h-7" />
          <div className="w-full">
            <Skeleton className="!w-8/12" />
            <Skeleton className="!w-6/12 mt-1" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AveragesSkeleton
